// extracted by mini-css-extract-plugin
export default {"imageWrapper":"AF-z","hovered":"BF-z","hoverImage":"CF-z","mainImage":"DF-z","imageNoBackground":"EF-z","fullSizeImage":"FF-z"};